import OpticksNumberCircle from "@/components/ui/OpticksNumberCircle/OpticksNumberCircle";
import step3_1 from "@/assets/integration-steps/microsoft/step_3_1.png";
import step3_2 from "@/assets/integration-steps/microsoft/step_3_2.png";
import step3_3 from "@/assets/integration-steps/microsoft/step_3_3.png";

interface Props {
  stepLabel?: string;
}

const MicrosoftIntegrationStep3 = ({ stepLabel }: Props) => {
  return (
    <div className="channels-integration-step microsoft-step-3">
      <div className="step-label-row">
        {stepLabel && <OpticksNumberCircle number={stepLabel} />}
        <h6>Assign the audience to your Microsoft campaigns</h6>
      </div>
      <div className="step-label-row">
        <p>
          Once you have the Audience created you will need to{" "}
          <b>assign it to all of your campaigns</b>. The most efficient way to
          do this is by editing the campaigns in bulk.
        </p>
      </div>
      <p>
        Select all your campaigns, click on "Audiences", then in{" "}
        <b>"Create association"</b>.
      </p>
      <img src={step3_1} alt="Screenshot of step 3.1 Microsoft Integration" />

      <hr />

      <p>
        In Campaign exclusions section click on <b>Add Exclusions</b>.
      </p>
      <img src={step3_2} alt="Screenshot of step 3.2 Microsoft Integration" />

      <hr />

      <div className="wrapper">
        <p>
          Then you will need to select <b>Remarketing lists</b> from the
          dropdown, search for the audience you just created and add it to the
          list.{" "}
        </p>
        <p>
          <b>
            Save the changes and your campaigns will start excluding invalid
            traffic
          </b>
          .
        </p>
      </div>
      <img src={step3_3} alt="Screenshot of step 3.3 Microsoft Integration" />
    </div>
  );
};

export default MicrosoftIntegrationStep3;
